// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Tasks/TicketTypes/index.css
// module id = 3067
// module chunks = 0